module.exports = __webpack_public_path__ + "img/specials-multislider-cjdr.abfd7574.jpg";